import React from 'react';
import './Promotions.css';
import { FaWhatsapp } from 'react-icons/fa';

// Importe suas imagens promocionais
import promoImg1 from '../../assets/images/promo1.jpg'; 
import promoImg2 from '../../assets/images/promo2.jpg'; 

const Promotions = () => {
    const phoneNumber = '553133602809';
    const whatsappMessage = 'Olá! Vi a promoção no site e gostaria de mais informações.';

  return (
    <section className="promotions-section">
      <div className="container">
        <h2 className="section-title">Ofertas que Eletrizam!</h2>
        <div className="promotions-grid">
          {/* Promoção 1 */}
          <div className="promo-card">
            <img src={promoImg1} alt="Promoção de Bateria Moura" className="promo-image" />
            <div className="promo-info">
              <h3>Bateria Moura 60Ah</h3>
              <p className="promo-description">A marca líder com a confiança que seu carro precisa. Instalação inclusa!</p>
              <a 
                href={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(whatsappMessage)}`} 
                target="_blank" 
                rel="noopener noreferrer"
                className="promo-button"
              >
                <FaWhatsapp /> Consultar Preço
              </a>
            </div>
          </div>

          {/* Promoção 2 */}
          <div className="promo-card">
            <img src={promoImg2} alt="Promoção de Bateria Heliar" className="promo-image" />
            <div className="promo-info">
              <h3>Bateria Heliar 70Ah</h3>
              <p className="promo-description">Tecnologia e durabilidade para veículos com maior demanda de energia.</p>
              <a 
                href={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(whatsappMessage)}`} 
                target="_blank" 
                rel="noopener noreferrer"
                className="promo-button"
              >
                <FaWhatsapp /> Consultar Preço
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Promotions;